import React from 'react';
import {
  styled,
  TableCell as MuiTableCell,
  tableCellClasses,
} from '@mui/material';

export const TableCell = styled(MuiTableCell)(({ theme }) => ({
  [`&.${tableCellClasses.root}`]: {
    border: 0,
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'transparent',
    fontWeight: '400',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
